var exports = {
  "kL": "StreamerModeTab.module__container___UWVvbD",
  "sm": "StreamerModeTab.module__behaviorGroup___UWVvbD",
  "e9": "StreamerModeTab.module__behaviorLegend___UWVvbD",
  "Jm": "StreamerModeTab.module__behaviorStack___UWVvbD",
};

module.exports = exports;
